import { render, staticRenderFns } from "./MedicalStudent.vue?vue&type=template&id=68ae1f04&scoped=true"
import script from "./MedicalStudent.vue?vue&type=script&lang=js"
export * from "./MedicalStudent.vue?vue&type=script&lang=js"
import style0 from "./MedicalStudent.vue?vue&type=style&index=0&id=68ae1f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae1f04",
  null
  
)

export default component.exports